const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const validateLoginEmail = (email) => {
  if (!email) return 'Email is required';
  if (!emailPattern.test(email)) return 'Please enter a valid email address';
  return '';
};

export const validateLoginPassword = (password) => {
  if (!password) return 'Password is required';
  return '';
};

export const mapLoginErrorCodeToMessage = (code) => {
  if (
    code === 'auth/user-not-found' ||
    code === 'auth/wrong-password' ||
    code === 'auth/invalid-credential' ||
    code === 'auth/invalid-login-credentials'
  ) {
    return 'Invalid email or password';
  }

  if (code === 'auth/user-disabled') {
    return 'This account is disabled. Contact support.';
  }

  if (code === 'auth/too-many-requests') {
    return 'Too many failed attempts. Please try again later.';
  }

  if (code === 'auth/network-request-failed') {
    return 'Network error. Please check your connection and try again.';
  }

  if (code === 'auth/invalid-email') {
    return 'Invalid email address';
  }

  return 'Failed to sign in. Please check your credentials.';
};

export const mapPasswordResetErrorCodeToMessage = (code) => {
  if (code === 'auth/invalid-email') {
    return 'Invalid email address';
  }

  if (code === 'auth/too-many-requests') {
    return 'Too many reset attempts. Please try again later.';
  }

  if (code === 'auth/network-request-failed') {
    return 'Network error. Please check your connection and try again.';
  }

  return 'Failed to send password reset email. Please try again.';
};
